export default "__VITE_ASSET__DTj4nxPh__"